export const CLOUD_ERROR_CODES = {
  // generic
  INVALID_REQUEST: "invalid_request",
  INTERNAL_ERROR: "internal_error",
  RATE_LIMITED: "rate_limited",
  AUTH_REQUIRED: "auth_required",
  ADMIN_AUTH_REQUIRED: "admin_auth_required",
  ADMIN_PERMISSION_REQUIRED: "ADMIN_PERMISSION_REQUIRED",
  ENTITLEMENT_REQUIRED: "ENTITLEMENT_REQUIRED",
  INVALID_CREDENTIALS: "invalid_credentials",
  INVALID_REFRESH_TOKEN: "invalid_refresh_token",
  INVALID_ADMIN_CREDENTIALS: "invalid_admin_credentials",

  // tenant / license
  TENANT_NOT_FOUND: "TENANT_NOT_FOUND",
  TENANT_ALREADY_EXISTS: "TENANT_ALREADY_EXISTS",
  INVALID_TENANT_ID: "INVALID_TENANT_ID",
  INVALID_TENANT_NAME: "INVALID_TENANT_NAME",
  INVALID_TENANT_OWNER_EMAIL: "INVALID_TENANT_OWNER_EMAIL",
  INVALID_TENANT_OWNER_NAME: "INVALID_TENANT_OWNER_NAME",
  INVALID_TENANT_OWNER_PASSWORD: "INVALID_TENANT_OWNER_PASSWORD",
  INVALID_TENANT_OWNER_PASSWORD_CONFIRMATION: "INVALID_TENANT_OWNER_PASSWORD_CONFIRMATION",
  USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
  USER_NOT_FOUND: "USER_NOT_FOUND",
  USER_NOT_IN_TENANT: "USER_NOT_IN_TENANT",
  INVALID_USER_EMAIL: "INVALID_USER_EMAIL",
  INVALID_USER_NAME: "INVALID_USER_NAME",
  INVALID_USER_PASSWORD: "INVALID_USER_PASSWORD",
  INVALID_USER_ROLE: "INVALID_USER_ROLE",
  INVALID_USER_STATUS: "INVALID_USER_STATUS",
  INVALID_LICENSE_PLAN: "INVALID_LICENSE_PLAN",
  INVALID_LICENSE_STATUS: "INVALID_LICENSE_STATUS",
  INVALID_LICENSE_EXPIRES_AT: "INVALID_LICENSE_EXPIRES_AT",
  INVALID_DEVICE_LIMIT: "INVALID_DEVICE_LIMIT",
  INVALID_ENTITLEMENTS: "INVALID_ENTITLEMENTS",
  LICENSE_INACTIVE: "LICENSE_INACTIVE",

  // device
  DEVICE_LIMIT_EXCEEDED: "DEVICE_LIMIT_EXCEEDED",
  DEVICE_REVOKED: "DEVICE_REVOKED",
  DEVICE_NOT_ACTIVE: "DEVICE_NOT_ACTIVE",
  DEVICE_NOT_FOUND: "DEVICE_NOT_FOUND",

  // usage / quota
  INVALID_USAGE_TYPE: "INVALID_USAGE_TYPE",
  INVALID_USAGE_QUANTITY: "INVALID_USAGE_QUANTITY",
  QUOTA_EXCEEDED: "QUOTA_EXCEEDED",
  RESERVATION_NOT_FOUND: "RESERVATION_NOT_FOUND",
  RESERVATION_NOT_ACTIVE: "RESERVATION_NOT_ACTIVE",
  COMMIT_EXCEEDS_RESERVATION: "COMMIT_EXCEEDS_RESERVATION",

  // billing
  BILLING_PROVIDER_DISABLED: "BILLING_PROVIDER_DISABLED",
  INVALID_BILLING_WEBHOOK_SIGNATURE: "INVALID_BILLING_WEBHOOK_SIGNATURE",
  BILLING_ORDER_NOT_FOUND: "BILLING_ORDER_NOT_FOUND",
  BILLING_PLAN_NOT_FOUND: "BILLING_PLAN_NOT_FOUND",
  INVALID_BILLING_SETTINGS: "INVALID_BILLING_SETTINGS",
  ALIPAY_QR_CODE_CREATE_FAILED: "ALIPAY_QR_CODE_CREATE_FAILED",

  // rule bundle
  INVALID_RULE_BUNDLE_VERSION: "INVALID_RULE_BUNDLE_VERSION",
  INVALID_RULE_BUNDLE_EXPIRES_AT: "INVALID_RULE_BUNDLE_EXPIRES_AT",
  RULE_BUNDLE_EXPIRED: "RULE_BUNDLE_EXPIRED",
  INVALID_RULE_BUNDLE_PAYLOAD: "INVALID_RULE_BUNDLE_PAYLOAD",
  INVALID_RULE_BUNDLE_PLATFORM: "INVALID_RULE_BUNDLE_PLATFORM",
  RULE_BUNDLE_UNAVAILABLE: "RULE_BUNDLE_UNAVAILABLE",

  // desktop updates
  DESKTOP_UPDATE_RELEASE_NOT_FOUND: "DESKTOP_UPDATE_RELEASE_NOT_FOUND",
  DESKTOP_UPDATE_ARTIFACT_NOT_FOUND: "DESKTOP_UPDATE_ARTIFACT_NOT_FOUND",
  INVALID_DESKTOP_UPDATE_SIGNATURE: "INVALID_DESKTOP_UPDATE_SIGNATURE",

  // sync
  SYNC_DEVICE_NOT_TRUSTED: "SYNC_DEVICE_NOT_TRUSTED",
  SYNC_DEVICE_REVOKED: "SYNC_DEVICE_REVOKED",
  SYNC_RECORD_REJECTED: "SYNC_RECORD_REJECTED",
  SYNC_BLOB_NOT_FOUND: "SYNC_BLOB_NOT_FOUND",
  INVALID_SYNC_PAYLOAD: "INVALID_SYNC_PAYLOAD",
  // 与 store-cookie-fingerprint-cloud-sync 设计中错误码表对齐：
  // 这些 lower_snake_case 错误码用于 /api/sync/* 路由的强制鉴权 / 账号主体隔离 / 设备状态校验
  // 失败场景，便于桌面端按 Sync_Service 状态机的不可重试错误码分支处理。
  SYNC_AUTH_FAILED: "auth_failed",
  SYNC_DEVICE_UNAUTHORIZED: "device_unauthorized",
  SYNC_DATA_INTEGRITY_VIOLATION: "data_integrity_violation"
} as const;

export type CloudErrorCode =
  (typeof CLOUD_ERROR_CODES)[keyof typeof CLOUD_ERROR_CODES];
